export const NGRX_CACHE_LIMIT_IN_SECONDS = 60;

export function isInCacheLimit(requestTimestamp: number, limitInSeconds = NGRX_CACHE_LIMIT_IN_SECONDS): boolean {
  if (requestTimestamp === null) {
    return false;
  }
  return Date.now() - requestTimestamp > limitInSeconds * 1000
    ? false
    : true;
}
